module.exports = __webpack_public_path__ + "img/Alderney.254901fe.svg";